const countDecimalPlaces = require('./common_independent').countDecimalPlaces;
const ActiveSymbols      = require('../../common/active_symbols');
const BinarySocket       = require('../../base/socket');
const getPropertyValue   = require('../../../_common/utility').getPropertyValue;

/*
 * Symbols object parses the active_symbols json that we get from socket.send({active_symbols: 'brief'}
 * and outputs in usable form, it gives markets, underlyings
 *
 *
 * Usage:
 *
 * use `Symbols.details` to populate this object first
 *
 * then use
 *
 * `Symbols.markets` to get markets like Forex, Random etc
 * `Symbols.underlyings` to get underlyings
 *
 */

const Symbols = (() => {
    let trade_markets             = {};
    let trade_markets_list        = {};
    let trade_underlyings         = {};
    let names                     = {};
    let is_active_symbols_cached  = false;

    const details = (data) => {
        // eslint-disable-next-line no-console
        console.log('🔍 Symbols.details - Input data:', data);
        const all_symbols  = data.active_symbols;
        // eslint-disable-next-line no-console
        console.log('🔍 Symbols.details - all_symbols count:', all_symbols?.length || 0);
        // eslint-disable-next-line no-console
        console.log('🔍 Symbols.details - First symbol sample:', all_symbols?.[0]);
        
        trade_markets      = ActiveSymbols.getMarkets(all_symbols);
        // eslint-disable-next-line no-console
        console.log('🔍 Symbols.details - trade_markets:', Object.keys(trade_markets || {}));
        
        trade_markets_list = ActiveSymbols.getMarketsList(all_symbols);
        // eslint-disable-next-line no-console
        console.log('🔍 Symbols.details - trade_markets_list:', Object.keys(trade_markets_list || {}));
        
        trade_underlyings  = ActiveSymbols.getTradeUnderlyings(all_symbols);
        // eslint-disable-next-line no-console
        console.log('🔍 Symbols.details - trade_underlyings:', Object.keys(trade_underlyings || {}));
        // eslint-disable-next-line no-console
        console.log('🔍 Symbols.details - First market underlyings sample:', trade_underlyings?.[Object.keys(trade_underlyings || {})[0]]);
        
        names              = ActiveSymbols.getSymbolNames(all_symbols);
        // eslint-disable-next-line no-console
        console.log('🔍 Symbols.details - names count:', Object.keys(names || {}).length);
    };

    const getUnderlyingPipSize = (underlying) => (
        new Promise((resolve) => {
            const req = { active_symbols: 'brief' };
            const options = { skip_cache_update: is_active_symbols_cached };
            BinarySocket.send(req, options).then(active_symbols => {
                details(active_symbols);
                const market             = ActiveSymbols.getSymbols(active_symbols);
                is_active_symbols_cached = true;

                // if we disable a symbol in API, pipsize won't be available
                // but we can still draw historical trades' charts
                // so we should handle getting undefined from this function
                const pipValue = getPropertyValue(market[underlying], ['pip_size']);
                resolve(countDecimalPlaces(pipValue));
            });
        })
    );

    return {
        details,
        markets      : list => (list ? trade_markets_list : trade_markets),
        getName      : symbol => names[symbol],
        underlyings  : () => trade_underlyings,
        getAllSymbols: () => names,
        getUnderlyingPipSize,
    };
})();

module.exports = Symbols;
